import { API } from "@/main.js";

const state = {
  allUsers: []
};

const getters = {
  users: state => state.allUsers
};

const mutations = {
  SET_ALL_USERS(state, result) {
    state.allUsers = result;
  }
};

const actions = {
  fetchAllUsers({ commit }, fields) {
    return new Promise((resolve, reject) => {
      API.user.getAll(
        fields,
        result => {
          resolve(result);
          commit("SET_ALL_USERS", result.data.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },
  fetchAvailableUsers({ commit }) {
    return new Promise((resolve, reject) => {
      API.user.getAvailableUsers(
        result => {
          resolve(result);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  fetchUserCompanies({ commit }, params) {
    return new Promise((resolve, reject) => {
      API.user.getAssociatedCompanies(
        params,
        result => {
          resolve(result.data.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  fetchUserByID({ commit }, { id, includes }) {
    return new Promise((resolve, reject) => {
      API.user.getByID(
        id,
        includes,
        resp => {
          resolve(resp.data.data[0]);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  DELETE_USER_BY_ID({ commit }, id) {
    return new Promise((resolve, reject) => {
      API.user.delete(
        id,
        resp => {
          resolve(resp);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  addUser({ commit }, data) {
    return new Promise((resolve, reject) => {
      API.user.create(
        data,
        resp => {
          resolve(resp.data.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  editUserByID({ commit }, { id, updatedData }) {
    return new Promise((resolve, reject) => {
      API.user.edit(
        id,
        updatedData,
        resp => {
          resolve(resp.data.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  changePassword({ commit }, { uuid, data }) {
    return new Promise((resolve, reject) => {
      API.user.changePassword(
        uuid,
        data,
        () => {
          resolve();
        },
        error => {
          reject(error);
        }
      );
    });
  },
  
  getUserPreference({ commit }, data ) {
    return new Promise((resolve, reject) => {
      API.user.getUserPreference(
        data,
        () => {
          resolve();
        },
        error => {
          reject(error);
        }
      );
    });
  },

  changeUserPreference({ commit }, data ) {
    return new Promise((resolve, reject) => {
      API.user.changeUserPreference(
        data,
        () => {
          resolve();
        },
        error => {
          reject(error);
        }
      );
    });
  },

  revokeUserToken({ commit }, { uuid }) {
    return new Promise((resolve, reject) => {
      API.user.revokeToken(
        uuid,
        () => {
          resolve();
        },
        error => {
          reject(error);
        }
      );
    });
  },

  downloadAllUsers({ commit }) {
    return new Promise((resolve, reject) => {
      API.user.downloadAllUsers(
        resp => {
          resolve(resp.data.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },
};

export default { state, getters, actions, mutations };



// WEBPACK FOOTER //
// ./src/store/modules/users.js